import { Dispatch } from 'redux'
import * as AvailableUnitsApi from 'redux/api/AvailableUnits'

import * as availableUnitsActions from './actions'

import { useThunkActions } from 'redux/actions/useThunkActions'

export function tryGetAvailableUnits() {
  return (dispatch: Dispatch): Promise<void> => {
    dispatch(availableUnitsActions.getAll())

    // Never rejects — failures dispatch getAllFailed so that app
    // initialization (Promise.all in initializeApp) always proceeds.
    return AvailableUnitsApi.getAll()
      .then((response) => {
        dispatch(availableUnitsActions.getAllSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(availableUnitsActions.getAllFailed())
      })
  }
}

export const useAvailableUnitsActions = () => {
  return {
    tryGetAvailableUnits: useThunkActions(tryGetAvailableUnits)
  }
}
